module.exports = __webpack_public_path__ + "media/mypage/images/menu/spm4-cc62173456e8683cfb50a789a37f036e.png";